export const examples: {
    name: string,
    content: string, 
}[] = [
    {
        name: 'Hello world!',
        content: [
            '// Print with the "print" keyword',
            'print "Hello World!";',
        ].join('\n'),
    },
    {
        name: 'Expressions',
        content: [
            '// Some basic arithmetic works as you\'d expect.',
            'print 1 + 1; // = 2',
            'print 0.1 + 0.2; // = 0.3',
            'print 8 - 1; // = 7',
            'print 10 * 2; // = 20',
            'print 35 / 5; // = 7',
            '',
            '// Negation uses the ! symbol',
            'print !true; // = false',
            'print !false; // = true',
            '',
            '// Equality is ===',
            'print 1 == 1; // = true',
            'print 2 == 1; // = false',
            '',
            '// Inequality is !==',
            'print 1 != 1; // = false',
            'print 2 != 1; // = true',
            '',
            '// More comparisons',
            'print 1 < 10; // = true',
            'print 1 > 10; // = false',
            'print 2 <= 2; // = true',
            'print 2 >= 2; // = true',
                '',
            '// Strings are concatenated with +',
            'print "Hello " + "world!"; // = "Hello world!"',
            'print "1, 2, " + 3; // = "1, 2, 3"',
        ].join('\n'),
    },
    {
        name: 'Flow Control',
        content: [
            '// The `if` structure works as you\'d expect',
            'var condition = true;',
            'if (condition) {',
            '    print "yes";',
            '} else {',
            '    print "no";',
            '}',
            '',
            '// As does `while`',
            'var a = 1;',
            'while (a < 10) {',
            '    print "While " + a;',
            '    a = a + 1;',
            '}',
            '',
            '// The `for` loop is the same as C and Java:',
            '// initialization; continue condition; iteration.',
            'for (var a = 1; a < 10; a = a + 1) {',
            '    print "For " + a;',
            '}',
        ].join('\n'),
    },
    {
        name: 'Function',
        content: [
            '// Functions are defined with the "fun" keyword',
            'fun fibonacci(n) {',
            '    if (n <= 1) return n;',
            '    return fibonacci(n - 2) + fibonacci(n - 1);',
            '}',
            '',
            'for (var i = 0; i < 10; i = i + 1) {',
            '    print "Fibonacci " + fibonacci(i);',
            '}',
            '',
            'fun makeClosure() {',
            '    var i = 0;',
            '    ',
            '    // You can define a closure into another function',
            '    fun count() {',
            '        i = i + 1;',
            '        return i;',
            '    }',
            '',
            '   return count;',
            '}',
            '',
            'var counter = makeClosure();',
            'for (var i = 0; i < 10; i = i + 1) {',
            '    print "Closure " + counter();',
            '}',
        ].join('\n'),
    },
    {
        name: 'Classes',
        content: [
            '// Class definition',
            'class Rectangle {',
            '    // Contructor',
            '    init(height, width) {',
            '        this.height = height;',
            '        this.width = width;',
            '    }',
            '',
            '    // Method',
            '    calcArea() {',
            '        return this.height * this.width;',
            '    }',
            '',
            '    // Static methods',
            '    class equals(a, b) {',
            '        return a.height == b.height and a.width == b.width;',
            '    }',
            '}',
            '',
            'var square = Rectangle(10, 10);',
            'print "Area: " + square.calcArea();',
            '',
            'var anotherSquare = Rectangle(10, 10);',
            'print "Equals? " + Rectangle.equals(square, anotherSquare);',
        ].join('\n'),
    }
]


// WEBPACK FOOTER //
// ./src/playground/examples.ts